import React from "react";
import { Spinner } from "../../atoms/Spinner/Spinner";
import { Retry, Root } from "./SaveStatusLabel.styles";
import type { SaveStatusLabelProps } from "./SaveStatusLabel.types";

const SPINNER_SIZE = 12;
const SPINNER_STROKE = 2.25;

/** One save state as text: "Saving…" with a spinner, "Saved", or the error with its Retry. */
export const SaveStatusLabel: React.FC<SaveStatusLabelProps> = ({
  status,
  labels,
  appearance = "label",
  onRetry,
  className,
}) => (
  <Root
    className={className}
    role={status === "error" ? "alert" : "status"}
    data-status={status}
    $status={status}
    $appearance={appearance}
  >
    {status === "saving" && <Spinner size={SPINNER_SIZE} strokeWidth={SPINNER_STROKE} />}
    {status === "saved" && <span aria-hidden>{"\u2713\u00A0"}</span>}
    {labels[status]}
    {status === "error" && onRetry && (
      <Retry type="button" onClick={onRetry}>
        {labels.retry}
      </Retry>
    )}
  </Root>
);

export default SaveStatusLabel;
